module.exports = new Promise(resolve => {
    const resolveProxy = () => {
        // this could probably just resolve window[entryScope], but to be safe handling for double init
        const proxy = {
            get: (request) => window['hlReactRootLegacyRemote'].get(request),
            init: (arg) => {
                try {
                    const initResult = window['hlReactRootLegacyRemote'].init(arg)
                    console.log('remote container', 'hlReactRootLegacyRemote', 'is initialized')
                    return initResult;
                } catch(e) {
                    console.warn('remote container', 'hlReactRootLegacyRemote', 'was already initialized')
                }
            }
        }
        resolve(proxy)
    }

    if (window['hlReactRootLegacyRemote']) {
        resolveProxy();
    } else {
        const script = document.querySelector('#hlReactRootLegacyRemote');
        script.onload = () => {
            resolveProxy();
        }
    }
})
;